<template>
  <div>
    <validation-observer ref="simpleRules">
      <b-card>
        <b-form @submit.prevent>
          <b-row>
            <b-col
              cols="12"
              lg="6"
              class="mb-2"
            >
              <b-card class="border h-100 mb-0">
                <div class="d-flex align-items-center mb-2">
                  <feather-icon
                    icon="UserIcon"
                    size="18"
                    class="mr-50 text-primary"
                  />
                  <h5 class="mb-0">
                    {{ $t('accountMembers.sections.generalInformation') }}
                  </h5>
                </div>

                <b-row>
                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      :label="$t('accountMembers.fields.username')"
                      label-for="mc-username"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('accountMembers.fields.username')"
                        rules="required"
                      >
                        <b-form-input
                          id="mc-username"
                          v-model="form.username"
                          :placeholder="$t('accountMembers.placeholders.username')"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      :label="$t('accountMembers.fields.phone')"
                      label-for="mc-phone"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('accountMembers.fields.phone')"
                        rules="required|digits:10"
                      >
                        <b-form-input
                          id="mc-phone"
                          v-model="form.phone"
                          :placeholder="$t('accountMembers.placeholders.phone')"
                          minlength="10"
                          maxlength="10"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      :label="$t('accountMembers.fields.password')"
                      label-for="mc-password"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('accountMembers.fields.password')"
                        vid="Password"
                        rules="required|min:8|password"
                      >
                        <b-form-input
                          id="mc-password"
                          v-model="form.password"
                          type="password"
                          :placeholder="$t('accountMembers.placeholders.password')"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      :label="$t('accountMembers.fields.confirmPassword')"
                      label-for="mc-confirm-password"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('accountMembers.fields.confirmPassword')"
                        rules="required|confirmed:Password"
                      >
                        <b-form-input
                          id="mc-confirm-password"
                          v-model="form.passwordConfirm"
                          type="password"
                          :placeholder="$t('accountMembers.placeholders.confirmPassword')"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      :label="$t('accountMembers.fields.nickname')"
                      label-for="mc-nickname"
                      class="mb-0"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('accountMembers.fields.nickname')"
                        rules="required"
                      >
                        <b-form-input
                          id="mc-nickname"
                          v-model="form.nickName"
                          :placeholder="$t('accountMembers.placeholders.nickname')"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
            <b-col
              cols="12"
              lg="6"
              class="mb-2"
            >
              <b-card class="border h-100 mb-0">
                <div class="d-flex align-items-center mb-2">
                  <feather-icon
                    icon="ShieldIcon"
                    size="18"
                    class="mr-50 text-primary"
                  />
                  <h5 class="mb-0">
                    {{ $t('accountMembers.sections.permission') }}
                  </h5>
                </div>

                <div class="permission-form">
                  <AbilityForm
                    ref="abilityForm"
                    :ability="ability"
                    @onSubmit="onSubmit"
                  />
                </div>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              class="text-right"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                size="lg"
                class="d-inline-flex align-items-center"
                @click.prevent="onSubmitForm"
              >
                <feather-icon
                  icon="UserPlusIcon"
                  size="18"
                  class="mr-50"
                />
                {{ $t('accountMembers.actions.submit') }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </validation-observer>
  </div>
</template>

<script>
/* eslint-disable */
import {
  BButton, BCard, BCol, BForm, BFormGroup, BFormInput, BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AbilityForm from '@/views/components/AbilityForm'
import agentService from '@/service/agentService'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    AbilityForm,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      abilityDisble: false,
      ability: [],
      form: {
        username: '',
        phone: '',
        password: '',
        passwordConfirm: '',
        nickName: '',
        ability: [],
      },
      // abilityForm: [0, 0, 0, 0, 0, 0],
      actionMap: {
        1: 'read',
        2: 'update'
      }
    }
  },
  mounted() {
  },
  methods: {
    onSubmit(v) {
      // if (v.length === 1 && v[0].subject === 'all' && v[0].action === 'manage') {
      //   const rules = this.$ability.rules
      //   const isMaster = rules.length === 1 && rules[0].subject === 'all' && rules[0].action === 'manage'
      //   if (isMaster === false) {
      //     console.log(this.$refs.abilityForm.getAll())
      //   } else {
      //     this.form.ability = v
      //   }
      // } else {
      //   this.form.ability = v
      // }
      this.form.ability = this.$refs.abilityForm.buildPermission(v);
    },
    onSubmitForm() {
      this.$refs.abilityForm.onSubmit()
      this.$refs.simpleRules.validate()
          .then(async success => {
            if (success) {
              this.$swal({
                dark: true,
                title: this.$t('accountMembers.messages.confirmTitle'),
                text: this.$t('accountMembers.messages.confirmAddSubAccount'),
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('accountMembers.messages.ok'),
                cancelButtonText: this.$t('accountMembers.messages.cancel'),
                customClass: {
                  confirmButton: 'btn btn-primary',
                  cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
              })
                  .then(async result => {
                    if (result.value) {
                      const formSender = { ...this.form }
                      delete formSender.passwordConfirm

                      const res = await agentService.postAuthen('subAccount', formSender)
                      if (res.status === 200) {
                        this.$toast({
                          component: ToastificationContent,
                          position: 'top-right',
                          props: {
                            title: this.$t('accountMembers.messages.success'),
                            icon: 'CoffeeIcon',
                            variant: 'success',
                            text: res.data,
                          },
                        })
                      } else {
                        this.$toast({
                          component: ToastificationContent,
                          position: 'top-right',
                          props: {
                            title: this.$t('accountMembers.messages.error'),
                            icon: 'AlertCircleIcon',
                            variant: 'danger',
                            text: res.data,
                          },
                        })
                      }
                    }
                  })
            }
          })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';

.permission-form {
  max-width: 520px;
}
</style>
